import { Dispatch } from "redux";
import { errorHandler } from "../../helpers/Functions";
import { Pagination, ResponseDetails } from "../../Interfaces/Interfaces";
import JiraService from "../../services/JiraService";

export const createTransferComplaint = (data: any) => {
  const api = new JiraService().createTransferComplaint(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: ResponseDetails) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const createBillComplaintAction = (data: any) => {
  const api = new JiraService().createBillComplaint(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: ResponseDetails) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: res.result?.issueKey,
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const createPOSComplaintAction = (data: any) => {
  const api = new JiraService().createPOSComplaint(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: ResponseDetails) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: res.result?.issueKey,
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const createFinanceComplaintAction = (data: any) => {
  const api = new JiraService().createFinanceComplaint(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: ResponseDetails) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: res.result?.issueKey,
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const createSavingsComplaintAction = (data: any) => {
  const api = new JiraService().createSavingsComplaint(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: ResponseDetails) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: res.result?.issueKey,
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const createGeneralComplaintAction = (data: any) => {
  const api = new JiraService().createGeneralComplaint(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: ResponseDetails) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: res.result?.issueKey,
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const AddComplaint = (data: any) => {
  const api = new JiraService().AddComplaint(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: ResponseDetails) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Complaint logged successfully",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getJiraRequestLog = (data: Pagination) => {
  const api = new JiraService().getJiraRequestLog(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: ResponseDetails) => {
        if (res) {
          dispatch({
            type: "LOGS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const jiraRequestLogDetails = (id: string) => {
  const api = new JiraService().jiraRequestLogDetails(id);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "LOGS_DETAILS",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Network request failed",
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const complaintDashboard = () => {
  const api = new JiraService().complaintDashboard();
  console.log(api);
  return (dispatch: Dispatch) => {
    api
      .then((res: ResponseDetails) => {
        if (res.successful) {
          dispatch({
            type: "COMPLAINT_DASHBOARD",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Network request failed",
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getBillTypesAction = () => {
  const api = new JiraService().getBillTypeService();
  console.log(api);
  return (dispatch: Dispatch) => {
    api
      .then((res: ResponseDetails) => {
        if (res.successful) {
          dispatch({
            type: "BILL_TYPE",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Network request failed",
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
